/**
 * SHIPPING BAR SYNC SCRIPT v6 — Reformation / FuelThemes
 * Place just before </body> in theme.liquid
 *
 * Snippet name: shipping-bar-snippet.liquid  ← must match your render calls
 * Cart drawer:  cart-drawer#Cart-Drawer > .side-panel-inner > .side-panel-header
 */

(function () {
  const FREE_SHIPPING_THRESHOLD = 12500; // $125.00 in cents

  function formatMoney(cents) {
return '$' + (cents / 100).toFixed(2);
  }

  function updateShippingBars(cartTotal) {
    const remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
    const pct       = Math.min(100, Math.round((cartTotal / FREE_SHIPPING_THRESHOLD) * 100));
    const isFree    = cartTotal >= FREE_SHIPPING_THRESHOLD;

    // Legacy cart-drawer bars (.shipping-bar-wrapper)
    document.querySelectorAll('.shipping-bar-wrapper').forEach(function (bar) {
      const msgEl  = bar.querySelector('.shipping-bar__message');
      const fillEl = bar.querySelector('.shipping-bar__fill');

      if (msgEl) {
        msgEl.classList.toggle('shipping-bar__message--success', isFree);
        msgEl.innerHTML = isFree
          ? '🎉 Hooray! You\'re eligible for <strong>Free Shipping</strong>'
          : 'You are <strong class="shipping-bar__amount">' + formatMoney(remaining) + '</strong> away from <strong>FREE Shipping!</strong>';
      }
      if (fillEl) {
        fillEl.style.width = pct + '%';
        fillEl.classList.toggle('shipping-bar__fill--complete', isFree);
      }
    });

    // Liquid snippet bars (.fsb) — used on product page and anywhere the snippet is rendered
    document.querySelectorAll('.fsb').forEach(function (bar) {
      const msgEl    = bar.querySelector('.fsb__message');
      const fillEl   = bar.querySelector('.fsb__fill');
      const trackEl  = bar.querySelector('.fsb__track');
      const amountEl = bar.querySelector('.fsb__amount');
      const metaEl   = bar.querySelector('.fsb__meta');
      const spentEl  = bar.querySelector('.fsb__meta-spent');
      const iconEl   = bar.querySelector('.fsb__icon');

      if (msgEl) {
        msgEl.classList.toggle('fsb__message--success', isFree);
        const textEl = msgEl.querySelector('.fsb__text');
        if (isFree) {
          if (iconEl) iconEl.textContent = '🎉';
          if (textEl) textEl.innerHTML = 'You\'ve unlocked <strong>Free Shipping!</strong> — Enjoy!';
        } else {
          if (iconEl) iconEl.textContent = '🚚';
          if (textEl) textEl.innerHTML = 'Add&nbsp;<strong class="fsb__amount">' + formatMoney(remaining) + '</strong>&nbsp;more for&nbsp;<strong>FREE&nbsp;Shipping!</strong>';
        }
      }

      if (fillEl) {
        fillEl.style.width = pct + '%';
        fillEl.classList.toggle('fsb__fill--complete', isFree);
      }

      if (trackEl) {
        trackEl.setAttribute('aria-valuenow', pct);
        trackEl.setAttribute('aria-label', 'Free shipping progress: ' + pct + '%');
      }

      if (spentEl) spentEl.textContent = formatMoney(cartTotal) + ' spent';

      // Show/hide the meta row based on threshold
      if (metaEl) metaEl.style.display = isFree ? 'none' : '';
    });
  }

  function syncWithCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(r => r.json())
      .then(cart => { updateShippingBars(cart.total_price); return cart; })
      .catch(err => console.warn('[ShippingBar] cart fetch failed:', err));
  }

  /* --------------------------------------------------
     FETCH INTERCEPT
     /cart/add    → returns item only, re-fetch cart
     /cart/change → returns full cart, read directly
     /cart/update → returns full cart, read directly
  -------------------------------------------------- */
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url ?? '');

    return _fetch.apply(this, args).then(function (response) {
      if (/\/cart\/add/.test(url)) {
        // Reformation returns only the added item here, so re-fetch full cart
        setTimeout(syncWithCart, 200);
        setTimeout(syncWithCart, 700);
        setTimeout(syncWithCart, 1500);
      } else if (/\/cart\/(change|update|clear)/.test(url)) {
        response.clone().json().then(data => {
          if (data && typeof data.total_price === 'number') {
            updateShippingBars(data.total_price);
          } else {
            syncWithCart();
          }
        }).catch(syncWithCart);
      }
      return response;
    });
  };

  /* --------------------------------------------------
     XHR INTERCEPT — Reformation's quantity-selector
     custom element uses XHR for cart/change calls
  -------------------------------------------------- */
  const _xhrOpen = XMLHttpRequest.prototype.open;
  const _xhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._sbUrl = url;
    return _xhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/(add|change|update|clear)/.test(this._sbUrl || '')) {
      this.addEventListener('load', function () {
        // Try to read cart total from XHR response directly
        try {
          const data = JSON.parse(this.responseText);
          if (data && typeof data.total_price === 'number') {
            updateShippingBars(data.total_price);
          } else {
            setTimeout(syncWithCart, 300);
          }
        } catch (e) {
          setTimeout(syncWithCart, 300);
        }
      });
    }
    return _xhrSend.apply(this, arguments);
  };

  /* --------------------------------------------------
     REFORMATION quantity-selector CUSTOM ELEMENT
     These fire change events on the input inside the
     quantity-selector when +/- is clicked in cart drawer
  -------------------------------------------------- */
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (
      input.tagName === 'INPUT' &&
      input.closest('quantity-selector') &&
      input.closest('cart-drawer, .cart-drawer')
    ) {
      // Qty changed in cart drawer — sync after short delay
      setTimeout(syncWithCart, 400);
      setTimeout(syncWithCart, 900);
    }
  });

  /* --------------------------------------------------
     ADD TO CART — product page button click
     Belt-and-suspenders alongside fetch intercept
  -------------------------------------------------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart]');
    if (btn) {
      // Show "Updating..." immediately so bar feels live
      document.querySelectorAll('.shipping-bar__message:not(.shipping-bar__message--success)').forEach(el => {
        el.innerHTML = 'Updating...';
      });
      document.querySelectorAll('.fsb__message:not(.fsb__message--success) .fsb__text').forEach(el => {
        el.innerHTML = 'Updating...';
      });
      setTimeout(syncWithCart, 400);
      setTimeout(syncWithCart, 900);
      setTimeout(syncWithCart, 1800);
    }
  });

  /* --------------------------------------------------
     REFORMATION cart:updated CUSTOM EVENT
     Fired by cart-drawer.js after every successful update
  -------------------------------------------------- */
  document.addEventListener('cart:updated', function (e) {
    const total = e.detail?.cart?.total_price ?? e.detail?.total_price;
    if (typeof total === 'number') {
      updateShippingBars(total);
    } else {
      syncWithCart();
    }
  });

  /* --------------------------------------------------
     INIT — immediately correct any stale Liquid value
     The Liquid snippet renders server-side cart total
     which may be stale; we overwrite it instantly with
     a live /cart.js fetch
  -------------------------------------------------- */
  syncWithCart(); // runs immediately — no DOMContentLoaded wait needed
                  // script is at end of body so DOM is already ready

})();
